<script setup>
import { reactive, watch } from 'vue';
import SpinnerWheel from '@/components/SpinnerWheel.vue';
import { store } from '@/store';
import router from '@/router';

const state = reactive({
  showSpinner : true,
})

watch(store, (newValue, oldValue) => {
  debugger
  console.log('eggs')
  if (newValue.userRole) {
    state.showSpinner = false;
    router.push({ name: 'home'})
  }
})
</script>
<template>

    <SpinnerWheel v-if="state.showSpinner"></SpinnerWheel>


</template>